import {
	simpleValidators,
	simpleValidatorsOptions,
	ValidationError,
	ValidatorOptions,
	ValidatorResult,
	ValueType,
	AntValidator,
} from 'Modules'
import { getLocaleTranslator } from 'Src/locale'

export const messageTranslator = getLocaleTranslator('validators')

export class ValidatorFactory {
	public static createValidator =
		<T extends ValueType, PayloadType = null>(
			validator?: (
				value: T,
				options: ValidatorOptions<PayloadType>
			) => ValidatorResult | Promise<ValidatorResult>
		) =>
		(options?: ValidatorOptions<PayloadType>): AntValidator =>
		async (rule, value, callback): Promise<void> => {
			try {
				const isMoment = value && value?.format
				const isAddress = value && value?.result

				if (!options?.required && !value?.toString()?.length) {
					callback()
					return
				}
				if (
					options?.required &&
					typeof value !== 'number' &&
					typeof value !== 'boolean' &&
					!(value instanceof File) &&
					!value?.file &&
					!(isMoment && value?.format()?.length) &&
					!(isAddress && value?.result?.length) &&
					!value?.length
				) {
					callback('Пожалуйста заполните')
					return
				}
				const validInfo = validator && (await validator(value, options))
				if (!validInfo?.result) {
					callback(validInfo?.error?.message)
					return
				}
				callback()
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e)
			}
		}
	public static createReduxValidator =
		() =>
		<T extends keyof typeof simpleValidators>(values: Partial<Record<T, ValueType | null>>) => {
			const errors = {} as Record<T, ValidationError['code']>
			;(Object.keys(values) as T[]).forEach((key) => {
				const res =
					simpleValidators[key] && values[key]
						? // @ts-ignore TODO NC-5191
						  simpleValidators[key](values[key] as string, simpleValidatorsOptions[key] || {})
						: undefined
				errors[key] = res?.error?.code
			})
			return errors
		}
}
